var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"p-0"},_vm._l((_vm.jobs),function(job){return _c('b-col',{key:job.id,staticClass:"mb-4",attrs:{"md":_vm.columns}},[_c('job-item',{attrs:{"job":job}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }